export const parseAmount = (amount: string) => {
  const parsed = parseFloat(amount)

  if (isNaN(parsed)) {
    return 999.99
  }

  return parsed
}

export const parsePartialAmount = (amount: string | undefined) => {
  if (typeof amount === 'undefined') {
    return undefined
  }

  const parsed = parseFloat(amount)

  return isNaN(parsed) ? undefined : parsed
}
